import { isNullOrUndefined } from "../../helper/utils";
import Splide from '@splidejs/splide';


Vue.component("item-image-carousel", {
    props: {
        maxQuantity:
        {
            type: Number,
            default: 10
        },
        imageUrlAccessor:
        {
            type: String,
            default: "url"
        },
        showThumbs:
        {
            type: Boolean,
            default: true
        },
        showDots:
        {
            type: Boolean,
            default: true
        },
        animationStyle:
        {
            type: String,
            default: "standard"
        },
        pluginPath:
        {
            type: String,
            default: ""
        }
        
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data()
    {
        return {
            currentItem: 0,
            splideThumbs: null
        };
    },

    computed:
    {
        currentVariation()
        {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },

        carouselImages()
        {
            return this.orderByPosition(
                this.$options.filters.itemImages(
                    this.currentVariation.images,
                    "urlPreview"
                )
            ).slice(0, this.maxQuantity);
        },

        singleImages()
        {
            return this.orderByPosition(
                this.$options.filters.itemImages(
                    this.currentVariation.images,
                    this.imageUrlAccessor
                )
            ).slice(0, this.maxQuantity);
        }
    },

    watch: {
        currentVariation:
        {
            handler(val, oldVal)
            {
                if (val !== oldVal)
                {
                    MagicZoom.stop('item-magiczoom')
                    setTimeout(() =>
                    {
                        this.reInitialize();
                    }, 1);
                }
            },
            deep: true
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.loadLightbox().then(() =>
            {
               
                //this.initCarousel();
               /* MagicZoom.registerCallback('onUpdate', function() {
                    console.log("DRINNNE")
                    console.log(arguments[1]);
                    if($(arguments[1]).attr('href').indexOf('-1.png') === -1){
                        
                        $('.item-img-gallery').addClass('full-size-image');
                    }else{
                        $('.item-img-gallery').removeClass('full-size-image');
                    }
                });*/
                this.initThumbCarousel();
            }).catch(event =>
            {
                console.log("error while loading lightbox", event);
            });
        });
    },

    methods:
    {
        getImageCount()
        {
            return this.carouselImages.length > this.maxQuantity ? this.maxQuantity : this.carouselImages.length;
        },

        reInitialize()
        {
            
            /*const $owl = $(this.$refs.single);

            $owl.trigger("destroy.owl.carousel");
            $owl.html($owl.find(".owl-stage-outer").html()).removeClass("owl-loaded");
            $owl.find(".owl-item").remove();

            const $thumbs = $(this.$refs.thumbs);

            $thumbs.trigger("destroy.owl.carousel");
            $thumbs.html($thumbs.find(".owl-stage-outer").html()).removeClass("owl-loaded");
            $thumbs.find(".owl-item").remove();*/
            $('.item-img-gallery').removeClass('full-size-image');
            this.splideThumbs.refresh();
            this.initCarousel();
            //this.initThumbCarousel();
        },

        initCarousel()
        {
            
            
            setTimeout(function(){
                
                MagicZoom.start('item-magiczoom');
                
            }, 100);
            
        },

        initThumbCarousel()
        {
            /*$(this.$refs.thumbs).owlCarousel({
                autoHeight       : true,
                dots             : false,
                items            : 3,
                lazyLoad         : true,
                loop             : false,
                margin           : 10,
                mouseDrag        : false,
                center           : false,
                nav              : true,
                navClass         : [
                    "owl-single-item-nav left carousel-control",
                    "owl-single-item-nav right carousel-control"
                ],
                navContainerClass: "",
                navText          : [
                    "<i class=\"owl-single-item-control fa fa-chevron-left\" aria-hidden=\"true\"></i>",
                    "<i class=\"owl-single-item-control fa fa-chevron-right\" aria-hidden=\"true\"></i>"
                ],
                smartSpeed       : 350
            });*/
 
            this.splideThumbs = new Splide(this.$refs.thumbs, {
                perPage: 3,
                gap    : '15px',
                pagination: false,
                arrows: true,
                mediaQuery: 'min',
                breakpoints:{
                    992: {
                        gap : '30px', 
                    }
                }
                
            }).mount(); 
        },

        goTo(index)
        {
            const $owl = $(this.$refs.single);

            $owl.trigger("to.owl.carousel", [
                index,
                350
            ]);
        },

        orderByPosition(list)
        {
            return list.sort(
                (entryA, entryB) =>
                {
                    if (entryA.position > entryB.position)
                    {
                        return 1;
                    }
                    if (entryA.position < entryB.position)
                    {
                        return -1;
                    }

                    return 0;
                });
        },

        getAltText(image)
        {
            return image && image.alternate ? image.alternate : this.$options.filters.itemName(this.currentVariation);
        },

        getImageName(image)
        {
            return image && image.name ? image.name : this.$options.filters.itemName(this.currentVariation);
        },

        loadLightbox()
        {
            return new Promise((resolve, reject) =>
            {
                const script = document.querySelector("script#magiczoomscript");

                if (!isNullOrUndefined(script))
                {
                    resolve();
                }
                else
                {
                    const script = document.createElement("script");

                    script.type = "text/javascript";
                    script.id = "magiczoomscript";
                    script.src = `${ this.pluginPath.replace('ceres','chattenglut') }/js/src/plugins/magiczoom.js`;

                    script.addEventListener("load", () => resolve(), false);
                    script.addEventListener("error", event => reject(event), false);

                    document.body.appendChild(script);
                }
            });
        }
    }
});
